// extracted by mini-css-extract-plugin
export default {"base":"SidebarExpander_base__MQqMa","sidebarIsCollapsed":"SidebarExpander_sidebarIsCollapsed__ldfEr","sidebarIsNotCollapsed":"SidebarExpander_sidebarIsNotCollapsed__pkGBG"};